import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import AppLayout from "../application/AppLayout";

import {appSetSettingsContent} from "../../redux/app/appActions";

import InputIcon from "@mui/icons-material/Input";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { styled, Grid, Paper, Typography } from '@mui/material';
const PREFIX = 'FourOhFourLayout';

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`
};

const StyledAppLayout = styled(AppLayout)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
        height: '100%',
    },

    [`& .${classes.paper}`]: {
        width: '360px',
        height: '220px',
    }
}));

export default function FourOhFourLayout() {

    const dispatch = useDispatch();

    // Get active location of app
    const location = useLocation();

    // Settings
    useEffect(() => {

        dispatch(appSetSettingsContent({ icon: null, content: {location: location.pathname, content: null} }));

    }, []);

    return (
        <StyledAppLayout>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: 'calc(100% - 64px)' }}
            >
                <Grid item xs={12}>
                    <div className={classes.paper} style={{width: '360px', height: '220px'}}>
                        <div
                            style={{
                                height: '60px',
                                width: 'calc(100% - 16px)',
                                padding: '16px',
                                textAlign: 'center',
                            }}
                        >
                            <SentimentVeryDissatisfiedIcon color="primary" style={{ fontSize: '64px' }} />
                        </div>
                        <div
                            style={{
                                width: 'calc(100% - 16px)',
                                textAlign: 'center',
                                padding: '8px',
                                marginTop: '16px'
                            }}
                        >
                            <Typography variant="h6" gutterBottom>
                                404
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                Opps! Page not found :(
                            </Typography>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </StyledAppLayout>
    );
}
